export function shiftRight8(binaryStr) {
  return (binaryStr || '')
    .split(/[\s]+/)
    .filter(Boolean)
    .map((bin) => String.fromCharCode(parseInt(bin, 2) >> 8))
    .join('');
}
